import { useContextFallback } from '@prenuvo/halo';

import { AddendumContext } from './addendum.context';

export const useAddendum = () => useContextFallback(AddendumContext);
